import React from 'react';

import LinkWithAuthorization from '@appComponents/LinkWithAuthorization';
import * as RESOURCES from '@constants/resources';
import {SECURITY_PRIVILEGES_UPDATE} from '@constants/variables';
import {IconSquare} from '@appComponents/IconCollection';

export const getTunnelStatusIcon = (isPlaceholderForAutoAssignment, tunnelStatusStarted = false) => {
    let icon;

    if (isPlaceholderForAutoAssignment) {
        icon = (
            <span className='--customIcon-gray'>
                <IconSquare name='cogs' />
            </span>
        );
    } else if (tunnelStatusStarted) {
        icon = (
            <span className='--customIcon-green'>
                <IconSquare name='check' inverted/>
            </span>
        );
    } else {
        icon = (
            <span className='--customIcon-red'>
                <IconSquare name='square outline' inverted/>
            </span>
        );
    }

    return icon;
};

export const generateTunnelRows = (tunnel) => {
    return [
        {
            header: 'Push',
            body: 'Tunneler push',
        },
        {
            header: 'Client',
            body: (
                <LinkWithAuthorization
                    link={{
                        name: 'clients.edit',
                        params: {id: tunnel.client.id},
                    }}
                    newWindow={true}
                    authorization={{
                        [RESOURCES.CLIENT]: SECURITY_PRIVILEGES_UPDATE,
                    }}
                >
                    {tunnel.client.name}
                </LinkWithAuthorization>
            ),
        },
        {
            header: 'Tunnel',
            body: (
                <LinkWithAuthorization
                    link={{
                        name: 'clients.products.thirdParty.tunnels.edit',
                        params: {id: tunnel.client.id, thirdPartyClientTunnelId: tunnel.id},
                    }}
                    newWindow={true}
                    authorization={{
                        [RESOURCES.CLIENT]: SECURITY_PRIVILEGES_UPDATE,
                    }}
                >
                    {tunnel.name}
                </LinkWithAuthorization>
            ),
        },
        {
            header: 'Info',
            body: tunnel.is_placeholder_for_auto_assignment ?
                'A tunnel should be automatically assigned shortly before the start of the broadcast' : null,
            hidden: !tunnel.is_placeholder_for_auto_assignment,
        },
        {
            header: 'VTD tunnel',
            body: tunnel.vtd_tunneler ? `${tunnel.vtd_tunneler.name} (${tunnel.vtd_tunnel_id})` : null,
            hidden: tunnel.is_placeholder_for_auto_assignment,
        },
        {
            header: 'VTD tunnel status',
            body: tunnel.vtd_tunneler?.started ? 'Started' : 'Stopped',
            hidden: tunnel.is_placeholder_for_auto_assignment,
        },
    ];
};
